@if(loading){
<div class="flex flex-col justify-center items-center h-screen backdrop">
    
</div>
}
@else {
<mat-toolbar class="flex items-center" color="primary">
    @if(isCoordinator){
    <button class="max-w-[52px] mx-4" (click)="sidenav.toggle()">
        @if(sidenav.opened){
        <mat-icon class="align-middle">menu_open</mat-icon>
        }@else {
        <mat-icon class="align-middle">menu</mat-icon>
        }
    </button>
    }@else {
    <button class="max-w-[52px] mx-4" routerLink="/secure/employee/employee-portal-home">
        <mat-icon class="align-middle">home</mat-icon>
    </button>
    }   

    <img class="max-[500px]:size-16 logo-image px-1" alt="DRÄXLMAIER LOGO" src="img/drx-logo-white.svg" />
    <div class="flex items-center">
        <span class="max-[1030px]:text-xs max-[1300px]:text-sm text-wrap pl-4">         
            @if(isCoordinator){
                <div class="flex flex-row items-center max-[720px]:gap-2 gap-6">
                    {{titleForCoordinators}}
                    <span class="max-[720px]:text-xs  text-sm italic font-bold text-gray-200 block">TEST ENVIRONMENT</span>
                    <span  class ="max-[720px]:text-xs  text-sm italic font-bold text-gray-200 block">V1.3.7</span>
                </div>                
            }@else {
                {{titleAppForUsers}}
            }
        </span>
    </div>

    <div class="ml-auto grid grid-flow-col auto-cols-min">
        <div class="ml-auto items-center">
            <span>
                <button mat-icon-button (click)="logOut()">
                    <mat-icon>logout</mat-icon>
                </button>
            </span>
        </div>
    </div>
</mat-toolbar>
}

<mat-sidenav-container class="sideNavContainer w-full h-screen">
    <mat-sidenav #sidenav mode="side" [opened]="!isMobile && isCoordinator" class="sideNavBar" [fixedInViewport]="false">
        <mat-tree #tree [dataSource]="links" [childrenAccessor]="childrenAccessor">
            <mat-tree-node class="hover:bg-gray-100" *matTreeNodeDef="let node" matTreeNodePadding>
                @if(activeUrl.startsWith(node.link)){
                <span class="inline-block w-1 h-4 rounded bg-[#0097ac]"></span>
                }
                <button matButton class="w-full h-full px-5 text-justify" [routerLink]="node.link"
                    (click)="sidenav.toggle()">{{node.text}}</button>
            </mat-tree-node>
            <mat-tree-node class="hover:bg-gray-100" *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding
                matTreeNodeToggle>
                <button mat-icon-button matTreeNodeToggle>
                    <mat-icon
                        class="{{activeUrl.startsWith(node.link) ? 'text-[#0097ac]' : 'text-gray-600'}}">{{node.icon}}</mat-icon>
                </button>
                <p class="pt-1">{{node.text}}</p>
            </mat-tree-node>
        </mat-tree>
        <div class="user-info">
            <div class="flex flex-row items-center">
                <mat-icon class="text-orange-500 mr-2">security</mat-icon>
                <span class="text-sm font-medium text-gray-800">{{user?.name}}</span>
            </div>
            @if(isCoordinator){
            <div class="flex flex-row justify-center items-center">
                    <mat-chip-set class="flex items-center">
                        <mat-chip [highlighted]="true" >                                
                            <p class="text-xs items-center flex-shrink truncate max-w-[150px]">{{ permissionService.getScopeDisplayName() }}</p>
                        </mat-chip>
                    </mat-chip-set>
            </div>                           
            }
        </div>
    </mat-sidenav>

    <mat-sidenav-content>
        <app-viewer></app-viewer>
    </mat-sidenav-content>
</mat-sidenav-container>